module.exports = __webpack_public_path__ + "img/camera-lock.915a9a24.svg";